import config from "config/config";

export const isFlagEnabled = (flag) => config[flag] === "true";
